import { render, staticRenderFns } from "./CustomerDetailAccountStatement.vue?vue&type=template&id=01b0fc4e&scoped=true&"
import script from "./CustomerDetailAccountStatement.vue?vue&type=script&lang=js&"
export * from "./CustomerDetailAccountStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0fc4e",
  null
  
)

export default component.exports